// extracted by mini-css-extract-plugin
export default {"title":"DetailsTab_title__I9D4X","icon":"DetailsTab_icon__f5QB8","sendMailer":"DetailsTab_sendMailer__bvY9Y"};